import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_footprint_generic_json_order_export_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { shipment_id?: number, integration_name?: string, transaction_id?: string, order_lookup?: string }): Promise<{ messages?: string[], DatexOrderInfo?: any }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/footprint_generic_json_order_export_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

